import { Group } from '@/components/_common';
import ActionIcon from '@/components/_common/ActionIcon';
import StatusTag from '@/components/_common/StatusTag';
import { useWorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.hooks';
import { useWorkOrderComplement } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.hooks';
import {
  workorderComplementColor,
  workorderComplementLabel,
} from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { Descriptions, Popover } from 'antd';
import { useState } from 'react';
import { File } from 'react-feather';
import { Link } from 'react-router-dom';

interface Props {
  workOrderId?: number;
  complementId?: number;
}

export default function MigrationWorkOrderBinded(props: Props) {
  const [opened, setOpen] = useState(false);

  const complementDetail = useWorkOrderComplement(props.complementId, opened);
  const workOrderDetail = useWorkOrder(props.workOrderId, opened);

  const isLoading = complementDetail.isLoading || workOrderDetail.isLoading;
  const complement = complementDetail.data;
  const workOrder = workOrderDetail.data;

  const href = `/app/movements/workOrders/${props.workOrderId}/complements/${props.complementId}/generalInfo`;

  if (!props.complementId || !props.workOrderId) return null;

  return (
    <Popover
      title={
        !isLoading &&
        !!complement && (
          <Group gap={10}>
            <StatusTag
              color={workorderComplementColor[complement.status]}
              label={workorderComplementLabel[complement.status]}
            />

            <strong>{complement.complementIdentifier}</strong>
          </Group>
        )
      }
      content={
        <>
          {isLoading && 'Carregando...'}
          {!isLoading && complement && (
            <>
              <Descriptions
                layout="horizontal"
                column={1}
                style={{ maxWidth: 300, marginBottom: 16 }}
              >
                <Descriptions.Item
                  style={{ padding: 0 }}
                  label="Cliente"
                  labelStyle={{ fontWeight: 600 }}
                >
                  {workOrder?.customer?.name}
                </Descriptions.Item>
                <Descriptions.Item
                  style={{ padding: 0 }}
                  label="Veículo"
                  labelStyle={{ fontWeight: 600 }}
                >
                  {workOrder?.vehicle
                    ? `${workOrder?.vehicle?.licensePlate} - ${workOrder?.vehicle?.model}`
                    : 'Sem veículo'}
                </Descriptions.Item>
              </Descriptions>

              <Link style={{ fontWeight: 600 }} to={href}>
                Acessar orçamento
              </Link>
            </>
          )}
        </>
      }
      onOpenChange={setOpen}
    >
      <a href={href}>
        <ActionIcon style={{ pointerEvents: 'none' }}>
          <File style={{ flexShrink: 0 }} size={18} />
        </ActionIcon>
      </a>
    </Popover>
  );
}
